import { IForecastParameterDetail } from '../../interfaces/iforecast-parameter-detail';
import { ForecastDeclineCurveType } from '../forecast-decline-curve-type';
import { ForecastDurationOuomType } from '../forecast-duration-ouom-type';
import { ForecastParameter } from '../forecast-parameter';
import { ForecastParemeterProductType } from '../forecast-paremeter-product-type';
import { ForecastRatioCurveType } from '../forecast-ratio-curve-type';
import { ForecastRatioFluidType } from '../forecast-ratio-fluid-type';
import { ForecastRatioVolumeOuomType } from '../forecast-ratio-volume-ouom-type';
import { ForecastSegmentType } from '../forecast-segment-type';

export class ForecastParameterDetailBase {
  ForecastParameterDetailId: number;
  ForecastParemeterId: number | null;
  StartDay: number | null;
  EndDay: number | null;
  ForecastParamterProductTypeId: number;
  ForecastSegmentTypeId: number;
  ForecastDeclineCurveTypeId: number | null;
  ForecastWellHeaderId: number | null;
  ForecastDurationOuomTypeId: number | null;
  Duration: number | null;
  InitialRate: number | null;
  InitialDecline: number | null;
  NFactor: number | null;
  FinalDecline: number | null;
  FinalRate: number | null;
  MinimumDecline: number | null;
  ForecastRatioCurveTypeId: number | null;
  ForecastRatioFluidTypeId: number | null;
  RatioInitialRate: number | null;
  RatioFinalRate: number | null;
  ForecastRatioVolumeOuomTypeId: number | null;
  Remark: string | null;
  UpdatedBy: string;
  Created: Date;
  Updated: Date;
  CreatedBy: string;
  SegmentNumber: number;
  SegmentId: string;
  IsActive: boolean;

  ForecastDeclineCurveType?: ForecastDeclineCurveType;
  ForecastDurationOuomType?: ForecastDurationOuomType;
  ForecastRatioCurveType?: ForecastRatioCurveType;
  ForecastRatioFluidType?: ForecastRatioFluidType;
  ForecastRatioVolumeOuomType?: ForecastRatioVolumeOuomType;
  ForecastSegmentType?: ForecastSegmentType;
  ForecastParemeterProductType?: ForecastParemeterProductType;
  ForecastParameter?: ForecastParameter;

  constructor(item?: IForecastParameterDetail) {
    if (item) {

      this.ForecastParameterDetailId = item.ForecastParameterDetailId;
      this.ForecastParemeterId = item.ForecastParemeterId;
      this.StartDay = item.StartDay;
      this.EndDay = item.EndDay;
      this.ForecastParamterProductTypeId = item.ForecastParamterProductTypeId;
      this.ForecastSegmentTypeId = item.ForecastSegmentTypeId;
      this.ForecastDeclineCurveTypeId = item.ForecastDeclineCurveTypeId;
      this.ForecastWellHeaderId = item.ForecastWellHeaderId;
      this.ForecastDurationOuomTypeId = item.ForecastDurationOuomTypeId;
      this.Duration = item.Duration;
      this.InitialRate = item.InitialRate;
      this.InitialDecline = item.InitialDecline;
      this.NFactor = item.NFactor;
      this.FinalDecline = item.FinalDecline;
      this.FinalRate = item.FinalRate;
      this.MinimumDecline = item.MinimumDecline;
      this.ForecastRatioCurveTypeId = item.ForecastRatioCurveTypeId;
      this.ForecastRatioFluidTypeId = item.ForecastRatioFluidTypeId;
      this.RatioInitialRate = item.RatioInitialRate;
      this.RatioFinalRate = item.RatioFinalRate;
      this.ForecastRatioVolumeOuomTypeId = item.ForecastRatioVolumeOuomTypeId;
      this.Remark = item.Remark;
      this.UpdatedBy = item.UpdatedBy;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.CreatedBy = item.CreatedBy;
      this.SegmentNumber = item.SegmentNumber;
      this.SegmentId = item.SegmentId;
      this.IsActive = item.IsActive;

      this.ForecastDeclineCurveType = new ForecastDeclineCurveType(item.ForecastDeclineCurveType);
      this.ForecastDurationOuomType = new ForecastDurationOuomType(item.ForecastDurationOuomType);
      this.ForecastRatioCurveType = new ForecastRatioCurveType(item.ForecastRatioCurveType);
      this.ForecastRatioFluidType = new ForecastRatioFluidType(item.ForecastRatioFluidType);
      this.ForecastRatioVolumeOuomType = new ForecastRatioVolumeOuomType(item.ForecastRatioVolumeOuomType);
      this.ForecastSegmentType = new ForecastSegmentType(item.ForecastSegmentType);
      this.ForecastParemeterProductType = new ForecastParemeterProductType(item.ForecastParemeterProductType);
      this.ForecastParameter = new ForecastParameter(item.ForecastParameter);
    }
  }
}